import React from "react"
import { Collapsible } from "@base-ui/react/collapsible"
import { Icon } from "../icon"
import { cn } from "../utils"

// =============================================================================
// Props
// =============================================================================

export type StepperItemTriggerProps = {
  /** The step's label */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const triggerStyles = [
  // 'group' enables group-aria-[expanded=true] on the chevron
  "group",
  "flex w-full items-center justify-between gap-2",
  "text-sm font-semibold text-gray-900",
  "outline-2 outline-transparent outline-offset-2 rounded-[0.25rem] transition-colors focus-visible:outline-gray-900"
]

// =============================================================================
// Component
// =============================================================================

/**
 * The clickable label that expands or collapses an expandable step's content.
 *
 * Must be a descendant of an expandable `Stepper.Item`.
 */
export function StepperItemTrigger({ children }: StepperItemTriggerProps) {
  return (
    <Collapsible.Trigger
      data-slot="stepper-item-trigger"
      className={cn(triggerStyles)}
    >
      <span className="min-w-0 flex-1 text-start leading-6">{children}</span>
      <Icon
        name="down"
        size="md"
        className="shrink-0 transition-transform group-aria-[expanded=true]:-rotate-180"
      />
    </Collapsible.Trigger>
  )
}

StepperItemTrigger.displayName = "Stepper.ItemTrigger"
